class FilterSearch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.elements = {
      search: this.querySelector('[data-filter-search-el="search"]'),
      facets: this.querySelectorAll('[data-filter-search-el="facet"]'),
    }

    this.attachEventListeners();
    this.addClickOutsideListener();
  }

  attachEventListeners() {
    this.elements.search.addEventListener('input', (e) => this.filterList(e));
  }

  addClickOutsideListener() {
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.resetFilter();
      }
    });
  }

  filterList(e) {
    const searchTerm = this.elements.search.value.toLowerCase()

    this.elements.facets.forEach((facet) => {
      const facetValue = facet.dataset.label.toLowerCase()

      if (facetValue.includes(searchTerm)) {
        facet.style.display = 'flex'
        facet.parentElement.style.display = 'block'
      } else {
        facet.style.display = 'none'
        facet.parentElement.style.display = 'none'
      }
    })
  }

  resetFilter() {
    this.elements.search.value = '';
    this.elements.facets.forEach((facet) => {
      facet.style.display = 'flex';
    });
  }
}

customElements.define('filter-search', FilterSearch)
